import React, { memo } from 'react';
import {
	Control,
	FieldErrors,
	FieldValues,
	UseFormWatch,
} from 'react-hook-form';

import { Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EParametersFormValues } from '../../enums';

import styles from '../ConsistencyCheckOptions.module.scss';

interface IConsistencyDefaultOptions {
	control: Control;
	errors: FieldErrors;
	nodeTypesOptions: Array<TSelectOption>;
	technologiesOptions: Array<TSelectOption>;
	watch: UseFormWatch<FieldValues>;
}

const ConsistencyCheckDefaultOptions = ({
	control,
	errors,
	technologiesOptions,
	nodeTypesOptions,
	watch,
}: IConsistencyDefaultOptions) => {
	const vendor = watch(EParametersFormValues.vendor);
	const technology = watch(EParametersFormValues.technology);

	return (
		<div className={styles.groupOptions}>
			<Select
				control={control}
				disabled={!vendor}
				errorMessage={errors.technology?.message}
				isError={!!errors?.technology}
				label='Technology'
				name={EParametersFormValues.technology}
				options={technologiesOptions}
				placeholder='Select technology'
				required
			/>
			<Select
				control={control}
				disabled={!technology}
				errorMessage={errors.nodeType?.message}
				isError={!!errors?.nodeType}
				label='Node type'
				name={EParametersFormValues.nodeType}
				options={nodeTypesOptions}
				placeholder='Select node type'
				required
			/>
		</div>
	);
};

export default memo(ConsistencyCheckDefaultOptions);
